import { Injectable } from '@angular/core';
import { RequestService } from 'angular/resources/request.service';
import { RestResourceModule } from 'angular/resources/rest-resource.module';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

type FeatureUrls = {
    // usage example:
    // login: string;
};

export type FeatureToggles = {
    flags: FeatureTogglesDto;
    urls: FeatureUrls;
};

// use new or old urls based on the feature flag
// use `null`, if there is no old url (completely new feature)
function fromFlagsToUrls(flags: FeatureTogglesDto): FeatureUrls {
    return {
        // usage example:
        // login: flags.authMigration ? '/react/login' : null,
    };
}

const defaultFlags: FeatureTogglesDto = {
    useEightFractionalDigitsUPABidCheck: false
};

const apiUrl = 'feature-toggles';

// the new frontend is integrated via feature toggles,
// whenever a feature toggle is activated we change urls
// so the user can navigate to the app
@Injectable({
    providedIn: RestResourceModule
})
export class FeatureTogglesResource {
    constructor(private requestService: RequestService) {}

    public getUrls(): Observable<FeatureToggles> {
        return this.requestService.get<FeatureTogglesDto>(apiUrl).pipe(
            // synchronously return some default values and update them later on
            // this needed, because some parts of the platform (like the header)
            // are rendered immediately and don't render with a loading phase
            startWith(defaultFlags),
            map((flags) => {
                const urls = fromFlagsToUrls(flags);
                return { urls, flags };
            })
        );
    }
}
